// src/pages/Portfolio.js

import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

import ProductDetail from "../components/Portfolio/ProductDetail";

// Life Cycle Imports
import Men from "../components/Portfolio/LifeCycleObjects/Men";
import Women from "../components/Portfolio/LifeCycleObjects/Women";
import Kids from "../components/Portfolio/LifeCycleObjects/Kids";
import PregnantWomen from "../components/Portfolio/LifeCycleObjects/PregnantWomen";
import Menopause from "../components/Portfolio/LifeCycleObjects/Menopause";
import Lactating from "../components/Portfolio/LifeCycleObjects/Lactating";

// Condition Imports
import Neuroix from "../components/Portfolio/ConditionObjects/Neuroix";
import Eaztrium from "../components/Portfolio/ConditionObjects/Eaztrium";
import Diaet from "../components/Portfolio/ConditionObjects/Diaet";
import Cartilazen from "../components/Portfolio/ConditionObjects/Cartilazen";
import Dermvit from "../components/Portfolio/ConditionObjects/Dermvit";
import Osteoniplex from "../components/Portfolio/ConditionObjects/Osteoniplex";
import Onconein from "../components/Portfolio/ConditionObjects/Onconein";
import Ayucoxib from "../components/Portfolio/ConditionObjects/Ayucoxib";
import Cardiovascular from "../components/Portfolio/ConditionObjects/Cardiovascular";


// Regenerative Health Imports
import Oxyoptima from "../components/Portfolio/RegenerativeHealthObjects/Oxyoptima";
import Regeneivit from "../components/Portfolio/RegenerativeHealthObjects/Regeneivit";
import Orgashwin from "../components/Portfolio/RegenerativeHealthObjects/Orgashwin";
import Metabolein from "../components/Portfolio/RegenerativeHealthObjects/Metabolein";
import IoniQ from "../components/Portfolio/RegenerativeHealthObjects/IoniQ";

import B12Corrinoids from "../components/Portfolio/DeficienciesObjects/B12Corrinoids";
import LichenD3 from "../components/Portfolio/DeficienciesObjects/LichenD3";
import AlgalOmegaD3 from "../components/Portfolio/DeficienciesObjects/AlgalOmegaD3";
import MushroomD2 from "../components/Portfolio/DeficienciesObjects/MushroomD2";
import Multivitamin from "../components/Portfolio/DeficienciesObjects/Multivitamin";
import ETocochromanols from "../components/Portfolio/DeficienciesObjects/ETocochromanols";
import ETocopherols from "../components/Portfolio/DeficienciesObjects/ETocopherols";
import BetaCarotere from "../components/Portfolio/DeficienciesObjects/BetaCarotene";
import ACarotenoids from "../components/Portfolio/DeficienciesObjects/ACarotenoids";
import FoodFolate from "../components/Portfolio/DeficienciesObjects/FoodFolate";
import FoodBiotin from "../components/Portfolio/DeficienciesObjects/FoodBiotin";
import BComplex from "../components/Portfolio/DeficienciesObjects/BComplex";
import NaturalZinc from "../components/Portfolio/DeficienciesObjects/NaturalZinc";
import FoodSelenium from "../components/Portfolio/DeficienciesObjects/FoodSelenium";
import NaturalIronC from "../components/Portfolio/DeficienciesObjects/NaturalIronC";
import VitaminK1 from "../components/Portfolio/DeficienciesObjects/VitaminK1";
import VitaminK2 from "../components/Portfolio/DeficienciesObjects/VitaminK2";

const brandStyles = {
    primaryGreen: '#91C949',
    deepBlue: '#394C92',
    linkHover: '#68A637', // Slightly darker green for hover effect
    lightBg: '#F0F5EB', // A very light, green-tinted background
};

// ✅ Category Data
const categoryData = [
  {
    name: "Orgavitaz for Deficiencies",
    subcategories: [

      { name: "B12-Corrinoids", data: B12Corrinoids },
      { 
        name: "D- Phytosterols", 
        products: [ 
            { name: "Lichen D3", data: LichenD3 },
            { name: "Algal Omega D3", data: AlgalOmegaD3 },
            { name: "Mushroom D2", data: MushroomD2 },
        ]
      },
      { name: "Multivitamin", data: Multivitamin},
       { 
        name: "E-Tocochromanols", 
        products: [ 
            { name: "E Tocochromanols", data: ETocochromanols },
            { name: "E Tocopherols", data: ETocopherols },
        ]
      },
      { 
        name: "Provit-A Carotenoids", 
        products: [ 
            { name: "Beta Carotene", data: BetaCarotere },
            { name: "A Carotenoids", data: ACarotenoids },
        ]
      },
      { name: "Food-Folate", data: FoodFolate },
      { name: "Food-Biotin", data: FoodBiotin },
      { name: "Natural B-Complex", data: BComplex },
      { name: "Natural Zinc", data: NaturalZinc},
      { name: "Food Selenium", data: FoodSelenium},
      { name: "Natural Iron C", data: NaturalIronC},
      { 
        name: "Natural K", 
        products: [ 
            { name: "Vitamin-K1(Phylloquinone)", data: VitaminK1 },
            { name: "Vitamin K2-7(Menaquinone)", data: VitaminK2 },
        ]
      },
    ],
  },
  {
    name: "Orgavitaz for Conditions",
    subcategories: [
      { name: "Neuroix-12", data: Neuroix },
      { name: "Eaztrium", data: Eaztrium },
      { name: "Cartilazen", data: Cartilazen },
      { name: "Diaet", data: Diaet },
      { name: "Ayucoxib-10", data: Ayucoxib },
      { name: "Osteoniplex", data: Osteoniplex },
      { name: "Dermvit", },
      { name: "Onconein", },
      { name: "Cardiovascular", data: Cardiovascular}
    ],
  },
  {
    name: "Orgavitaz for Regenerative Health",
    subcategories: [
      { name: "Oxyoptima-Oxidative Stress", data: Oxyoptima },
      { name: "Regeneivit-DNA Repair", },
      { name: "Orgashwin-Longevity", data: Orgashwin },
      { name: "Metabolein-GLP-1", data: Metabolein },
      { name: "IoniQ-Cell Revital", data: IoniQ },
    ],
  },
  {
    name: "Orgavitaz for Life cycle",
    subcategories: [
      { name: "Kids", data: Kids },
      { name: "Men", data: Men },
      { name: "Women", data: Women },
      { name: "Pregnant Women",},
      { name: "Menopause",},
      { name: "Lactating",}
    ],
  },
];

// ✅ HeroSection Component
 export const HeroSection = ({ currentIndex, setCurrentIndex, autoPlay }) => {
  const banners = [
    {
      img: "/images/Portfolio/BannerImages/NutritionalDeficiencies.jpg",
      title: "Orgavitaz for Nutritional Deficiencies",
      subtitle: [
        "B12-Corrinoids ",
        "D-Phytosterols ",
        "Multivitamin ",
        "E-Tocochromanols ",
        "Provit-A Carotenoids ",
        "Food Folate ",
        "Food Biotin ",
        "Natural B-Complex ",
        "Zinc ",
        "Food Selenium ",
        "Iron C",
        "Vitamin K",

      ],
    },
    {
      img: "/images/Portfolio/BannerImages/ChronicConditions.jpg",
      title: "Orgavitaz for Chronic Conditions",
      subtitle: [
        "Neuroix-12 ",
        "Eaztrium ",
        "Diaet ",
        "Cartilazen ",
        "Dermvit ",
        "Osteoniplex ",
        "Onconein ",
        "Ayucoxib-10",
      ],
    },
    {
      img: "/images/Portfolio/BannerImages/RegenesisHealth.jpg",
      title: "Orgavitaz for Regenerative Health",
      subtitle: [
        "Oxyoptima - Oxidative Stress ",
        "Regeneivit - DNA Repair ",
        "Orgashwin - Longevity ",
        "Metabolein - GLP-1 ",
        "IoniQ - Cell Revital",
      ],
    },
    {
      img: "/images/Portfolio/BannerImages/LifeCycles.jpg",
      title: "Orgavitaz for Lifecycle Stages",
      subtitle: ["Kids ", "Men ", "Women ", "Pregnant Women", "Menopause", "Lactating"],
    },
  ];

  const [displayedSubtitle, setDisplayedSubtitle] = useState("");

  // Animate subtitle typing effect
  useEffect(() => {
    const fullText = banners[currentIndex].subtitle.join(", ").trim();
    let i = 0;
    setDisplayedSubtitle(""); // clear before typing
    const interval = setInterval(() => {
      if (i < fullText.length) {
        setDisplayedSubtitle(fullText.slice(0, i + 1));
        i++;
      } else {
        clearInterval(interval);
      }
    }, 70);

    return () => clearInterval(interval);
  }, [currentIndex]);

  // Auto-scroll only when autoPlay = true
  useEffect(() => {
    if (!autoPlay) return;
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % banners.length);
    }, 15000);
    return () => clearInterval(interval);
  }, [autoPlay, setCurrentIndex]);

  return (
    <div className="carousel-container position-relative">
      <style>{`
    /* Sets height to 600px for desktop/tablet and shrinks to 350px for mobile */
    .responsive-carousel-image {
        height: 600px; /* Default desktop height */
        object-fit: cover;
        transition: 0.8s ease;
    }
    @media (max-width: 868px) {
        .responsive-carousel-image {
            height: 400px; /* Reduced height for mobile/tablet */
        }
    }
    
    /* Ensures the caption text fits well on small screens */
    .carousel-caption-responsive {
        bottom: 5% !important; 
        width: 90% !important;
        padding: 10px !important;
        /* Ensure text doesn't flow outside the background box */
        max-width: 90%; 
    }
  `}</style>
      <img
        src={banners[currentIndex].img}
        className="d-block w-100 responsive-carousel-image"
        alt={`Banner ${currentIndex + 1}`}
      />
      <div
        className="carousel-caption text-center "
        style={{
          bottom: "10%",
          background: "rgba(0, 0, 0, 0.3)",
          borderRadius: "12px",
          padding: "15px",
          width: "75%",
          left: "50%",
          transform: "translateX(-50%)",
        }}
      >
        <h1 className="display-5 fw-bold text-warning mb-3" style={{backgroundColor: ""}}>
          {banners[currentIndex].title}
        </h1>
        <p className="fs-5 fw-bold text-white" style={{ whiteSpace: "pre-wrap" }}>
          {displayedSubtitle}
        </p>
      </div>
    </div>
  );
};


// ✅ Portfolio Page
const Portfolio = () => {
  const [activeCategoryIndex, setActiveCategoryIndex] = useState(0);
  const [activeSubIndex, setActiveSubIndex] = useState(0);
  // --- NEW STATE for nested products ---
  const [activeProductIndex, setActiveProductIndex] = useState(0);
  // -------------------------------------
  const [heroIndex, setHeroIndex] = useState(0);
  const [autoPlay, setAutoPlay] = useState(true);

  const activeCategory = categoryData[activeCategoryIndex];
  const activeSub = activeCategory.subcategories[activeSubIndex];
  
  // Check if the current subcategory has nested products
  const isNested = activeSub.products && activeSub.products.length > 0;
  
  // Determine the final product to display: either the nested product or the subcategory itself
  const activeProduct = isNested
    ? activeSub.products[activeProductIndex]
    : activeSub;


  const handleCategoryClick = (index) => {
    setActiveCategoryIndex(index);
    setActiveSubIndex(0);
    setActiveProductIndex(0); // Reset nested product index
    setHeroIndex(index); // show related banner
    setAutoPlay(false); // stop auto-scroll
  };

  const handleSubcategoryChange = (index) => {
    setActiveSubIndex(index);
    setActiveProductIndex(0); // Reset nested product index when changing subcategory
  };
  
  // --- NEW HANDLER for nested products ---
  const handleProductChange = (index) => {
    setActiveProductIndex(index);
  };
  // -------------------------------------


  return (
    <div className="portfolio-page">
      <HeroSection
        currentIndex={heroIndex}
        setCurrentIndex={setHeroIndex}
        autoPlay={autoPlay}
      />

      {/* Category Tabs */}
      <div className="container-fluid py-3 shadow-sm" style={{backgroundColor: brandStyles.linkHover}}>
        <ul className="nav nav-tabs justify-content-center border-0" role="tablist">
          {categoryData.map((cat, i) => (
            <li className="nav-item text-start" key={i} role="presentation">
              <button
                className={`nav-link fw-bold d-flex flex-column align-items-center ${
                  i === activeCategoryIndex
                    ? "active border-bottom-0 border-primary"
                    : "text-white"
                }`}
                onClick={() => handleCategoryClick(i)}
                style={{
                  fontSize: "1.2rem",
                  fontWeight: "600",
                  minWidth: "180px",
                  background: 'transparent',
                  color: i === activeCategoryIndex 
                      ? brandStyles.deepBlue
                      : 'white',
                  borderBottom: i === activeCategoryIndex 
                      ? `4px solid ${brandStyles.primaryGreen}`
                      : 'none',
                }}
              >
                <span>{cat.name}</span>
              </button>
            </li>
          ))}
        </ul>
      </div>

      {/* Subcategory Tabs (Level 2) */}
       <div
        className="container-fluid py-3 shadow-sm"
        style={{ position: "sticky", top: "0", zIndex: "1010", backgroundColor: brandStyles.deepBlue}}
      >
        <ul className="nav nav-pills justify-content-center flex-wrap">
          {activeCategory.subcategories.map((sub, idx) => (
            <li className="nav-item" key={idx}>
              <button
                className={`nav-link fw-semibold me-2 mb-2 ${
                  idx === activeSubIndex ? "active" : ""
                }`}
                onClick={() => handleSubcategoryChange(idx)}
                style={{
                  borderRadius: "8px",
                  padding: "8px 16px",
                  fontSize: "1rem",
                  fontWeight: "500",
                  backgroundColor: idx === activeSubIndex 
                    ? brandStyles.primaryGreen 
                    : 'white',
                  color: brandStyles.deepBlue,
                  border: `1px solid ${brandStyles.deepBlue}`,
                }}
              >
                {sub.name}
              </button>
            </li>
          ))}
        </ul>
      </div>
      
      {/* Nested Product Tabs (Level 3) - Only render if current subcategory has 'products' */}
      {isNested && (
        <div 
          className="container-fluid py-3 shadow-sm" 
          style={{ 
            position: "sticky", 
            top: "80px", // Adjust based on your header/nav height
            zIndex: "1005", 
            backgroundColor: brandStyles.primaryGreen 
          }}
        >
          <ul className="nav nav-pills justify-content-center flex-wrap">
            {activeSub.products.map((product, idx) => (
              <li className="nav-item" key={idx}>
                <button
                  className={`nav-link fw-semibold me-2 mb-2 ${
                    idx === activeProductIndex ? "active" : ""
                  }`}
                  onClick={() => handleProductChange(idx)}
                  style={{
                    borderRadius: "8px",
                    padding: "8px 16px",
                    fontSize: "1rem",
                    fontWeight: "500",
                    // Custom style for the third level
                    backgroundColor: idx === activeProductIndex
                      ? brandStyles.deepBlue
                      : 'white',
                    color: idx === activeProductIndex
                      ? 'white'
                      : brandStyles.deepBlue,
                    border: `1px solid ${brandStyles.deepBlue}`,
                  }}
                >
                  {product.name}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Breadcrumb */}
      <nav
        aria-label="breadcrumb"
        className="mb-4 bg-white shadow-sm py-2 px-3"
        style={{ 
          position: "sticky", 
          // Adjust top based on whether the nested tabs are present (approx 50px high)
          top: isNested ? "130px" : "80px", 
          zIndex: "1000" 
        }}
      >
        <ol className="breadcrumb mb-0">
          <li className="breadcrumb-item text-secondary">Portfolio</li>
          <li className="breadcrumb-item text-dark">{activeCategory.name}</li>
          
          {/* Subcategory */}
          {isNested ? (
            <li className="breadcrumb-item text-dark">{activeSub.name}</li>
          ) : (
            <li className="breadcrumb-item active text-dark" aria-current="page">
              {activeSub.name}
            </li>
          )}

          {/* Nested Product */}
          {isNested && (
            <li className="breadcrumb-item active text-dark" aria-current="page">
              {activeProduct.name}
            </li>
          )}
        </ol>
      </nav>

      {/* Product Details */}
      <div className="container-fluid p-4">
        <div className="p-4 bg-white rounded shadow-sm border">
          {/* Use activeProduct to get the data/component */}
          {activeProduct.data ? (
            <ProductDetail data={activeProduct.data} />
          ) : activeProduct.component ? (
            React.createElement(activeProduct.component)
          ) : (
            <p className="text-danger">
              "Details for <strong>{activeProduct.name}</strong> are currently being updated. Please check back soon or contact us for immediate assistance!"
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Portfolio;